import React, { useState } from "react";
import axios from "axios";
import { Input } from "./components/ui/input";
import { Button } from "./components/ui/button";
import { toast } from "sonner";

const ContactForm = ({ language, API }) => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.message) {
      toast.error(language === 'de' ? 'Bitte füllen Sie Name und Nachricht aus' : 'يرجى ملء الاسم والرسالة');
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success(language === 'de' ? 'Nachricht erfolgreich gesendet!' : 'تم إرسال الرسالة بنجاح!');
      setSent(true);
      setFormData({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => setSent(false), 5000);
    } catch (error) {
      console.error('Error sending message:', error);
      toast.error(language === 'de' ? 'Fehler beim Senden der Nachricht' : 'خطأ في إرسال الرسالة');
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center py-8 bg-green-50 rounded-lg">
        <div className="text-green-600 text-5xl mb-4">✓</div>
        <p className="text-green-800 font-semibold text-lg">
          {language === 'de' ? 'Nachricht erfolgreich gesendet!' : 'تم إرسال الرسالة بنجاح!'}
        </p>
        <p className="text-green-600 text-sm mt-2">
          {language === 'de' ? 'Wir werden uns bald bei Ihnen melden.' : 'سنتواصل معك قريباً'}
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {language === 'de' ? 'Name *' : 'الاسم *'}
          </label>
          <Input type="text" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} placeholder={language === 'de' ? 'Ihr Name' : 'اسمك'} required className="w-full" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {language === 'de' ? 'E-Mail' : 'البريد الإلكتروني'}
          </label>
          <Input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} placeholder={language === 'de' ? 'ihre@email.de' : 'example@email.com'} className="w-full" dir="ltr" />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {language === 'de' ? 'Telefonnummer' : 'رقم الهاتف'}
        </label>
        <Input type="tel" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} placeholder="+49 xxx xxxxxxx" className="w-full" dir="ltr" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {language === 'de' ? 'Nachricht *' : 'الرسالة *'}
        </label>
        <textarea value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} placeholder={language === 'de' ? 'Ihre Nachricht hier...' : 'اكتب رسالتك هنا...'} required rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500" />
      </div>
      <Button type="submit" disabled={sending} className="w-full bg-amber-600 hover:bg-amber-700 text-white py-3">
        {sending ? (
          <span className="flex items-center justify-center gap-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            {language === 'de' ? 'Wird gesendet...' : 'جاري الإرسال...'}
          </span>
        ) : (language === 'de' ? 'Nachricht senden' : 'إرسال الرسالة')}
      </Button>
    </form>
  );
};

export default ContactForm;
